module.exports = __webpack_public_path__ + "80363aa555c82df82910b14cbbaab239.svg";